export default function RecommendationDocumentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  editRecommendationDocumentDialog,
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Recommendation Document Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;
  vm.canEditItem = vm.canEdit;

  // Attach Event Handlers
  vm.handleEditRecommendationDocument = _handleEditRecommendationDocument;
  vm.handleUnattachRecommendationDocument = _handleUnattachRecommendationDocument;

  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditRecommendationDocument($event) {
    ssDialogService.dialogs.auditTrail.editRecommendationDocumentDialog = ssDialogService.alert(
      editRecommendationDocumentDialog.getOptions($event, {
        recommendationId: vm.recommendationId,
        document: vm.recommendationDocument,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.auditTrail.editRecommendationDocumentDialog);
  }

  function _handleUnattachRecommendationDocument($event) {
    ssDialogService.dialogs.auditTrail.deleteRecommendationDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Recommendation Document?',
        message: `Are you sure you want to remove document "${vm.recommendationDocument.description}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteRecommendationDocumentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.detachRecommendationDocument(vm.recommendationDocument.recommendationDocumentId)
      .then(() => {
        alerts.success('The document has been removed successfully.');
        $rootScope.$broadcast('refreshAMRecommendationDocuments', { recommendationId: vm.recommendationDocument.recommendationId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while removing the document.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteRecommendationDocumentConfirmDialog);
  }
}

RecommendationDocumentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'editRecommendationDocumentDialog'
];
